export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultFormGlobal = {
        idcredito: 0,
        idcotizacion: 0,
        idvehiculo: 0,
        idcliente: 0,
        credito_fecha: getCurrentDate(),
        credito_dia_pago: '',
        monto_venta: '',
        saldo_financiar: '',
        monto_enganche: '',
        enganche: '',
        interes_total: '',
        interes: '',
        plazo: '',
        plazo_anios: '',
        gps: '',
        seguro: '',
        otros: '',
        total_cuota: '',
        cuota_niv: '',
        vigencia_check: '',
        aprobacion_observaciones: '',
        vigencia_fecha: '',
        suma_dias_atraso_totales: '',
        suma_total_pagar: '',
        total_gastos_juridicos: '',
        total_deuda_credito: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormDeposit = {
        idmovimiento: '',
        idcaja: '',
        idbanco: '',
        boleta_numero: '',
        boleta_foto_path: '',
        boleta_foto_originalname: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        deposito_fecha: getCurrentDate(),
        deposito_moneda: '',
        deposito_monto: '',
        clean_deposito_monto: 0,
        deposito_dolares: '',
        clean_deposito_dolares: 0,
        deposito_quetzales: '',
        clean_deposito_quetzales: 0,
        deposito_observaciones: '',
        deposito_tipo_cambio: 7.8,
        movimiento_tipo: '',
        aprobacion_check: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultFormPreInventory = {
        idvehicledeposit: 0,
        valor: '',
        marca: '',
        modelo: '',
        linea: '',
        color: '',
        matricula: '',
        chasis: '',
    }

    const defaultFormLogBook = {
        descripcion: '',
        file: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    const defaultFormExpense = {
        idgasto: 0,
        idcredito: 0,
        gasto_fecha: getCurrentDate(),
        gasto_descripcion: '',
        gasto_monto: '',
        usuario_creo: '',
        fecha_creo: '',
        usuario_modifico: '',
        fecha_modifico: '',
        clean_gasto_monto: '',

    }
    
    const optionsTypeMoneda = [
        { value: 'QUETZAL', label: 'QUETZAL' },
        { value: 'DOLAR', label: 'DOLAR' },
    ];

    const optionsTypePayment = [
        { value: 'EFECTIVO', label: 'EFECTIVO' },
        { value: 'DEPOSITO', label: 'DEPOSITO' },
    ];

    const optionsAprobacionDeposit = [
        { value: 'APROBADO', label: 'APROBADO' },
        { value: 'PENDIENTE', label: 'PENDIENTE' },
        { value: 'RECHAZADO', label: 'RECHAZADO' },
    ];


    const optionsAprobacionCheck = [
        { value: 'CREDITO INCOBRABLE', label: 'CREDITO INCOBRABLE' },
        { value: 'FINALIZACION EXTRAORDINARIA', label: 'FINALIZACION EXTRAORDINARIA' },
    ];

   
    return Object.freeze({
        defaultFormGlobal,
        defaultDataModal,
        defaultFormDeposit,
        defaultFormLogBook,
        optionsTypeMoneda,
        optionsTypePayment,
        optionsAprobacionDeposit,
        defaultFormPreInventory,
        optionsAprobacionCheck,
        defaultFormExpense,
    })
}